import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {
  CheckNotes,
  GasSystemArea,
  InspectionGasExtinguishingSystem
} from '@authority-labs/api-interfaces';

@Component({
  selector: 'authority-labs-gas-extinguishing-system-test-results',
  templateUrl: './gas-extinguishing-system-test-results.component.html',
  styleUrls: ['./gas-extinguishing-system-test-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class GasExtinguishingSystemTestResultsComponent implements OnInit {
  @Input() inspection: InspectionGasExtinguishingSystem;

  mainItems: { label: string; value: string; notes: CheckNotes[] }[] = [];
  areasNotes: { title: string; notes: string[] }[] = [];

  ngOnInit(): void {
    this.mainItems = [
      {
        label: this.inspection.gasExtinguishingSystemDesign.main.hubLocation
          .title,
        value: this.inspection.gasExtinguishingSystemDesign.main.hubLocation
          .value,
        notes: this.inspection.gasExtinguishingSystemDesign.main.hubLocation.getNotes()
      },
      {
        label: this.inspection.gasExtinguishingSystemDesign.main.hubMadeFrom
          .title,
        value: this.inspection.gasExtinguishingSystemDesign.main.hubMadeFrom
          .value,
        notes: this.inspection.gasExtinguishingSystemDesign.main.hubMadeFrom.getNotes()
      },
      {
        label: this.inspection.gasExtinguishingSystemDesign.main.hubModel.title,
        value: this.inspection.gasExtinguishingSystemDesign.main.hubModel.value,
        notes: this.inspection.gasExtinguishingSystemDesign.main.hubModel.getNotes()
      },
      {
        label: this.inspection.gasExtinguishingSystemDesign.main
          .detectionSystemTestedBy.title,
        value: this.inspection.gasExtinguishingSystemDesign.main
          .detectionSystemTestedBy.value,
        notes: this.inspection.gasExtinguishingSystemDesign.main.detectionSystemTestedBy.getNotes()
      },
      {
        label: this.inspection.gasExtinguishingSystemDesign.main.protectedAreas
          .title,
        value: this.inspection.gasExtinguishingSystemDesign.main.protectedAreas
          .value,
        notes: this.inspection.gasExtinguishingSystemDesign.main.protectedAreas.getNotes()
      },
      {
        label: this.inspection.gasExtinguishingSystemDesign.main.siteRiskLevel
          .title,
        value: this.inspection.gasExtinguishingSystemDesign.main.siteRiskLevel
          .value,
        notes: this.inspection.gasExtinguishingSystemDesign.main.siteRiskLevel.getNotes()
      }
    ];

    this.areasNotes = this.inspection.gasExtinguishingSystemDesign.areas
      .map((area) => {
        const title =
          area?.gasExtinguishingSystem?.boardDetailsOrProtectedSpace?.value ||
          '--';
        const notes = new GasSystemArea(area)
          .getNotes()
          .filter((note) => note.addNotesToReport && note.notes)
          .filter((note) => !note.notes.includes('undefined'))
          .map((note) => note.notes);

        return { title, notes };
      })
      .filter((area) => area.notes.length > 0);
  }
}
